import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import StatsJS from 'stats.js'
import classNames from 'classnames'

const STATSCLASSNAME = `stats-${Math.floor(Math.random() * Math.floor(99999))}`

class Stats extends PureComponent {
    constructor(props) {
        super(props)

        this.handleTouchStart = this.handleTouchStart.bind(this)
        this.handleClick = this.handleClick.bind(this)
    }

    componentDidMount() {
        const { panel, className } = this.props

        this.stats = new StatsJS()
        this.stats.showPanel(panel)
        this.stats.dom.className = classNames(STATSCLASSNAME, className)
        this.stats.dom.addEventListener('touchstart', this.handleTouchStart)
        this.stats.dom.addEventListener('click', this.handleClick)

        document.body.appendChild(this.stats.dom)

        this.animate()
    }

    componentWillUnmount() {
        if (this.rafID) cancelAnimationFrame(this.rafID)

        this.stats.dom.removeEventListener('touchstart', this.handleTouchStart)
        this.stats.dom.removeEventListener('click', this.handleClick)
        document.body.removeChild(document.querySelector(`.${STATSCLASSNAME}`))
    }

    animate = () => {
        this.stats.update()
        this.rafID = requestAnimationFrame(this.animate)
    }

    handleTouchStart(event) {
        const { onTouchStart } = this.props
        onTouchStart && onTouchStart(event)
    }

    handleClick(event) {
        const { onClick } = this.props
        onClick && onClick(event)
    }

    render() {
        return null
    }
}

Stats.propTypes = {
    panel: PropTypes.number,
}

Stats.defaultProps = {
    panel: 0, // 0: fps, 1: ms, 2: mb, 3+: custom
}

export default Stats
